module.exports = __webpack_public_path__ + "img/营销伙伴01.aecc2433.png";